import {
  LoanHistoryPage,
  LoanSchedulePage,
  LoansPage,
  LoanStatementPage,
} from "@/modules/loan/pages";
import { FeatureToggle } from "@/shared/common/enums";
import type { BreadcrumbMatch } from "@/shared/common/types";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

enum Paths {
  Loans = "loans",
  LoanHistory = ":loanId/history",
  LoanSchedule = ":loanId/schedule",
  LoanStatement = ":loanId/statement",
}

export const loanRoutes: RouteObject = {
  path: Paths.Loans,
  element: <Layout/>,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.loans" })
  },
  children: [
    { path: "", element: <LoansPage/> },
    {
      path: Paths.LoanHistory,
      element: <LoanHistoryPage/>,
      handle: {
        breadcrumb: ({ params }: BreadcrumbMatch) => ({
          key: "breadcrumb.loanHistory",
          params: { id: params.id }
        })
      },
    },
    {
      path: Paths.LoanSchedule,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isLoanScheduleAvailable}
          element={<LoanSchedulePage/>}
        />
      ),
      handle: {
        breadcrumb: ({ params }: BreadcrumbMatch) => ({
          key: "breadcrumb.loanSchedule",
          params: { id: params.id }
        })
      },
    },
    {
      path: Paths.LoanStatement,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isLoanStatementAvailable}
          element={<LoanStatementPage/>}
        />
      ),
      handle: {
        breadcrumb: ({ params }: BreadcrumbMatch) => ({
          key: "breadcrumb.loanStatement",
          params: { id: params.id }
        })
      },
    }
  ],
};
